<template>
  <div>
    <div style="z-index: 888">
      <img :src="systemLogo" alt="logo" class="topLogo"/>
    </div>
    <div id="htWrap">
      <div class="camera-wrap">
        <div class="video-details-warp" @mousedown="move">
          <!-- 视频窗口 -->
          <video id="myPlayer" :src=videoPath controls playsInline webkit-playsinline autoplay>
          </video>
          <span class="iconfont" @click="closeVideo">
          <i class="el-icon-close"></i>
        </span>
        </div>
      </div>
      <button class="move-btn" @click="transitionAnimation('', [1483, 1574, 361], [1412, 535, 2165],5000, function () {
      rotate_flag = true;
      integratedManagement();
      rotateView();
    })"></button>
    </div>
    <loadingBox style="z-index: 2001" :m='[99,99,99,99,99,100]' ></loadingBox>
  </div>
</template>
<script>
import {
  getNowTime,
  getNowFormatDate,
  transitionAnimation,
  rotateView,
  videoMonitor,
  pathFlow,
  setOpacity,
  setVisible
} from '../assets/js/tools/instruments'
import Easing from '../assets/js/external/easing'
import EZUIKit from "../assets/js/external/ezuikit"
import cookie from 'vue-cookies'
import _ from 'lodash'
import {getSession, setSession} from '@/assets/js/tools/instruments'
import loadingBox from "../components/loading"

export default {
  name: "generalSituation",
  components: {
    loadingBox
  },
  data() {
    return {
      dataModel: null,          //数据容器
      graphView: null,           //2D
      g3d: null,                 //3D,
      event: null,
      relativelayout: null,
      vbox: null,
      echartview: null,
      hbox: null,
      label: null,
      htview: null,
      dm: null,
      elec_data: [],
      water_data: [],
      air_data: [],
      tol_data: [],
      uvDlt: 0.02,
      uv_elec: 0.03,
      videoPath: '',
      timer: '',
      timer2: '',
      timer3: '',
      loading_progress: 0,
      side_flag: 'left',
      hide_flag: true,
      rotate_flag: '',
      chart_flag: false,
      chart2_flag: false,
      water_flag: false,
      video_flag: false,
      alarm_flag: false,
      select_switchRoom: false,
      select_elec: false,
      imageArr: [],
      hide_building: true,
      internalsName: [],
      internalsName_env: [],
      car_moving: false,
      metro_task1: null,
      metro_task2: null,
      elevatorTask_l: null,
      elevatorTask_r: null,
      floor_l: null,
      floor_r: null,
      line_anim: null,
      road_anim: null,
      rotate_anim: null,
      transition_anim: null,
      is_click: false,
      menu_index: '',
      dataSource: [],  //轮播图数据
      fire_alarm: '',
      fire_time: '',
      fire_category: '',
      fire_value: '',
      fire_location: '',
      pv_time: '',
      pv: '',
      pv_category: '',
      pv_value: '',
      pv_location: '',
      personInfo1Status: false,
      personInfo2Status: false,
      carInStatus: false,
      carOutStatus: false,
      currentDataValueArr: [],
      alarmAnim: '',
      systemLogo: 'logo',
      userName: '',
    }
  },
  beforeCreate() {
    window.htUrl('power');
  },
  watch: {
    videoPath(val) {
      this.$nextTick(function () {
        new EZUIKit.EZUIPlayer('myPlayer');
      })
    },
    personInfo1Status(val) {
      let people_info = this.g3d.dm().getDataByTag("people-info");
      people_info.s('brightness', 0.8);
      people_info.p3(2739, 678, 2186);
      people_info.s('3d.visible', val);
    },
    personInfo2Status(val) {
      let people_info2 = this.g3d.dm().getDataByTag("people-info2");
      people_info2.s('brightness', 0.8);
      people_info2.p3(2739, 675, 2176);
      people_info2.s('3d.visible', val);
    },
    carInStatus(val) {
      let car_in = this.g3d.dm().getDataByTag("car-in");

      car_in.s('3d.visible', val);
    },
    carOutStatus(val) {
      let car_out = this.g3d.dm().getDataByTag("car-out");
      car_out.s('3d.visible', val);
    }
  },
  mounted() {
    let logoName = cookie.get('logo') ? cookie.get('logo') : 'logo';
    this.systemLogo = require('../assets/images/header/' + logoName + '.png');
    let userName = getSession('userName')
    this.userName = userName
    this.addGraphView();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer3);
    this.timer = null;
    this.timer3 = null;
  },
  methods: {
    // 防抖
    onSearch: _.debounce(function () {
      // console.log(222222222)
    }, 2000),
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel);  // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      this.g3d = new ht.graph3d.Graph3dView();

      this.g3d.addToDOM(document.getElementById('htWrap'));
      this.graphView.addToDOM(this.g3d.getView());
      let _this = this;

      //进度条
      // this.graphView.deserialize('displays/loading-bar.json', function () {
      //   let loading_bar = _this.dm.getDataByTag('loading-bar')
      //   if (ht.Default.getShape3dModelMap()['models/北自园区/高亮楼宇/大门围墙.json']) {
      //     setVisible(loading_bar, false);
      //   } else {
      //     setVisible(loading_bar, true);
      //     ht.Default.handleModelLoaded = function (name, model) {
      //       _this.loading_progress += 100 / 41
      //       loading_bar.a('ht.value', _this.loading_progress);
      //       if (Math.ceil(_this.loading_progress) === 100) {
      //         setVisible(loading_bar, false);
      //       }
      //     }
      //   }
      // })

      this.graphView.deserialize('displays/wfc.json', function () {
        let date_con = _this.dm.getDataByTag('date');
        date_con.s('text', getNowFormatDate());
        let week_con = _this.dm.getDataByTag('week');
        let title = _this.dm.getDataByTag('title');
        let date = new Date();
        let week_arr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
        let week_text = date.getDay() - 1;
        week_con.s('text', week_arr[week_text]);
        let time_con = _this.dm.getDataByTag('time');
        _this.timer = setInterval(function () {
          time_con.s('text', getNowTime());
        }, 1000);

        if (_this.userName == 'ceeczhny') {
          title.s('text', '中国能建智慧园区')
        }

        // let defalutLogo = _this.projectLogo == 'logo' ? true : false;
        // let logo = _this.dm.getDataByTag('logo');
        // // logo.s('2d.visible', defalutLogo);
        // let lsdLogo = _this.dm.getDataByTag('lsd_logo');
        // lsdLogo.s('2d.visible', !defalutLogo);
        _this.carousel();
      });
      // 阻止 2d模型交互的事件冒泡
      var div2d = _this.graphView.getView();
      var handler = function (event) {
        if (_this.graphView.getDataAt(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
      div2d.addEventListener('mousedown', handler);
      div2d.addEventListener('mousemove', handler);
      div2d.addEventListener(getWheelEventName(div2d), handler)

      function getWheelEventName(element) {
        if ('onwheel' in element) {
          return 'wheel';
        } else if (document.onmousewheel !== undefined) {
          return 'mousewheel';
        } else {
          return 'DOMMouseScroll';
        }
      }

      this.g3d.deserialize('scenes/北自园区0825.json', function (json, dm, g3d, datas) {
        _this.g3d.setEye(8299, 21974, 2257);
        _this.g3d.setCenter(1194, 258, 2551);
        _this.g3d.setFar(1000000);
        // 入场动画之后触发的功能暂时放在这里
        _this.rotate_flag = false;
        _this.getChart();
        _this.integratedManagement();
        pathFlow(_this, 'road_anim', ['traffic_line'], 30, 0.012, 'all.uv.offset', 'move');
        // _this.setDefault();
        const info1 = _this.g3d.dm().getDataByTag('info1');
        const info2 = _this.g3d.dm().getDataByTag('info2');
        setVisible(info1, false);
        setVisible(info2, false);
      });
      //设置交互限制
      let mapInteractor = new ht.graph3d.MapInteractor(this.g3d);
      this.g3d.setInteractors([mapInteractor]); //禁止3d图形下移翻转
      ht.Default.graph3dViewMaxPhi = Math.PI / 2 //最大角度
      ht.Default.graph3dViewMinPhi = 0 //最小角度
      // 左键可拖拽编辑图元，右键可改变视角方向，采用这样的方式一般会结合键盘w|s|a|d按键进行漫游操作
      this.g3d.setMouseRoamable(false);
      this.g3d.setFar(1000000);

      this.graphView.mi(this.buttonMonitor);
    },
    transitionAnimation,
    rotateView,
    //轮播效果
    carousel() {
      this.$get('generalsituation/gettenalarmdata')
          .then((response) => {
            for (let i in response) {
              let createdAt = response[i].createdAt;
              let alarmCategoryName = response[i].alarmCategoryName;
              let alarmDescription = response[i].alarmDescription;
              let alarmValue = response[i].alarmValue
              this.dataSource.push(createdAt + ' ' + alarmCategoryName + ' ' + alarmDescription + ' ' + alarmValue);
            }
          })
          .catch((response) => {
          })
      const carousel = this.graphView.dm().getDataByTag('carousel1')
      let i = 1;
      carousel.a('ht.dataSource', this.dataSource)
      let timer = setInterval(function () {
        carousel.a('ht.offset2', i)
        i += 0.6;
      }, 20)
      this.graphView.addInteractorListener(e => {
        if (e.data && e.data._tag === 'carousel1') {
          if (e.kind === "onEnter") {
            let node = e.data;
            if (node._tag === 'carousel1') {
              clearInterval(timer);
            }
          } else if (e.kind === "onLeave") {
            let node = e.data;
            if (node._tag === 'carousel1') {
              clearInterval(timer);
              timer = setInterval(function () {
                carousel.a('ht.offset2', i)
                i += 0.6;
              }, 20)
            }
          } else if (e.kind === "onClick") {
            this.$router.push('/alarmManagement');
          }
        }
      })
    },
    // 获取带有呼吸灯的面板
    repeatAnimObj() {
      // let info1 = this.g3d.dm().getDataByTag("info1");
      // let info2 = this.g3d.dm().getDataByTag("info2");
      let env_info1 = this.g3d.dm().getDataByTag("env-info1");
      let env_info2 = this.g3d.dm().getDataByTag("env-info2");
      let env_info3 = this.g3d.dm().getDataByTag("env-info3");
      let env_info4 = this.g3d.dm().getDataByTag("env-info4");
      let car_info1 = this.g3d.dm().getDataByTag("car-info1");
      let car_info2 = this.g3d.dm().getDataByTag("car-info2");
      let people_info = this.g3d.dm().getDataByTag("people-info");
      let people_info2 = this.g3d.dm().getDataByTag("people-info2");
      let parking_info1 = this.g3d.dm().getDataByTag("parking-info1");
      let parking_info2 = this.g3d.dm().getDataByTag("parking-info2");
      return {
        breatheLight: (v) => {
          // 信息面板的呼吸灯
          // info1.a('breathe', v * 100);
          // info2.a('breathe', v * 100);
          env_info1.a('breathe', v * 100);
          env_info2.a('breathe', v * 100);
          env_info3.a('breathe', v * 100);
          env_info4.a('breathe', v * 100);
          car_info1.a('breathe', v * 100);
          car_info2.a('breathe', v * 100);
          people_info.a('breathe', v * 100);
          people_info2.a('breathe', v * 100);
          parking_info1.a('breathe', v * 100);
          parking_info2.a('breathe', v * 100);
        }
      }
    },
    // 呼吸灯添加动画
    repeatAnim() {
      // 取出需要循环的动画方法 然后传入 v 和 需要的参数
      const {breatheLight} = this.repeatAnimObj();
      const {easeOut} = Easing;
      const actionAnim = () => {
        const animOptions = {
          duration: 1000,
          easing: v => easeOut(v),
          action(v) {
            // 信息模板的呼吸灯
            breatheLight(v)
          },
          finishFunc: () => {
            actionAnim()
          }
        }
        ht.Default.startAnim(animOptions)
      }
      actionAnim();
    },
    // 报警圈动画
    setDefault(tagArr) {
      const fireScaleList = [],
          fireMinScale = 0,
          fireMaxScale = 1.8,
          fireDltScale = 0.02;
      if (tagArr) {
        tagArr.forEach((item) => {
          fireScaleList.push(this.g3d.dm().getDataByTag(item),);
        })
      }
      this.alarmAnim ? this.alarmAnim.stop(true) : '';
      this.alarmAnim = ht.Default.startAnim({
        frames: Infinity, // 动画帧数
        interval: 30, // 动画帧间隔毫秒数
        action: () => {
          fireScaleList.forEach(node => {
            let s = node.getScaleX() + fireDltScale;
            if (s > fireMaxScale) s = fireMinScale;
            if (s >= fireMinScale - 0.4) {
              node.s(
                  "shape3d.opacity",
                  0.32 * (fireMaxScale - s) * 2.5
              );
            } else {
              node.s("shape3d.opacity", 0.32);
            }
            node.setScale3d(s, s, s);
          });
        }
      });
    },
    //车辆面板
    updateCarinfo() {
      let car_info1 = this.g3d.dm().getDataByTag("car-info1");
      let car_info2 = this.g3d.dm().getDataByTag("car-info2");
      this.$get('generalsituation/getparkingmanageinfo', [0, 0]).then((response) => {
        let length = response.length;
        this.carInStatus = false;
        this.carOutStatus = false;
        if (length === 1) {
          if (response[0].channelId === 15903) {
            car_info1.a('cardNo0', response[0].plateNum);
            car_info1.a('inTime0', response[0].inTime);
            car_info1.a('cardType0', response[0].cardType);
            car_info1.a('picture1', response[0].picPlateNum);
            car_info1.a('clip1', 1);
            this.carInStatus = true;
            this.startMetroAnimate('right');
          } else if (response.data[0].channelId === 15904) {
            car_info2.a('cardNo1', response[0].plateNum);
            car_info2.a('inTime1', response[0].outTime);
            car_info2.a('cardType1', response[0].cardType);
            car_info2.a('picture2', response[0].picPlateNum);
            car_info2.a('clip1', 1);
            this.carOutStatus = true;
            this.startMetroAnimate('left');
          }
        } else if (length === 2) {
          if (response[0].length != 0) {
            this.carInStatus = true;
            car_info1.a('cardNo0', response[0].plateNum);
            car_info1.a('inTime0', response[0].inTime);
            car_info1.a('cardType0', response[0].cardType);
            car_info1.a('picture1', response[0].picPlateNum);
            car_info1.a('clip1', 1);
          }
          if (response[1].length != 0) {
            this.carOStatus = true;
            car_info2.a('cardNo1', response[1].plateNum);
            car_info2.a('inTime1', response[1].outTime);
            car_info2.a('cardType1', response[1].cardType);
            car_info2.a('picture2', response[1].picPlateNum);
            car_info2.a('clip1', 1);
          }
          this.startMetroAnimate('both');
        }
      })
    },
    // 电梯
    elevatorAnimate() {
      let _this = this;
      let elevator_west = this.g3d.dm().getDataByTag("elevator-west");
      let elevator_east = this.g3d.dm().getDataByTag("elevator-east");
      let buildingD = this.g3d.dm().getDataByTag("D座");
      let elevator_west_info = this.g3d.dm().getDataByTag("ele-left-info");
      let elevator_east_info = this.g3d.dm().getDataByTag("ele-right-info");
      let elevator_west_info2 = this.g3d.dm().getDataByTag("ele-left-info2");
      let elevator_east_info2 = this.g3d.dm().getDataByTag("ele-right-info2");
      let width = buildingD.getWidth() + 100;
      let direction_l = 1;
      let direction_r = -1;
      let elevatorTask_l = {
        interval: 50,
        action: (data) => {
          if (data === elevator_west) {
            let currentY = data.p3()[1], direction = direction_l;
            let speed = 2;
            let position_left = [935 - width / 2, currentY, 2688];
            elevator_west_info.p3(position_left);
            elevator_west_info2.p3(position_left);
            if (Math.abs(currentY) <= 990) {
              // 左侧电梯的运行动画
              if (Math.abs(currentY) === 754.16172) {
                this.floor_l = 2;
                elevator_west_info.a('floor', '02');
                elevator_west_info2.a('floor', '02');
                data.p3(695, currentY + direction * speed, 2772);
              } else if (Math.abs(currentY) === 794.16172) {
                this.floor_l = 3;
                elevator_west_info.a('floor', '03');
                elevator_west_info2.a('floor', '03');
                data.p3(695, currentY + direction * speed, 2772);
              } else if (Math.abs(currentY) === 834.16172) {
                this.floor_l = 4;
                elevator_west_info.a('floor', '04');
                elevator_west_info2.a('floor', '04');
                data.p3(695, currentY + direction * speed, 2772);
              } else if (Math.abs(currentY) === 874.16172) {
                this.floor_l = 5;
                elevator_west_info.a('floor', '05');
                elevator_west_info2.a('floor', '05');
                data.p3(695, currentY + direction * speed, 2772);
              } else if (Math.abs(currentY) === 910.16172) {
                this.floor_l = 6;
                elevator_west_info.a('floor', '06');
                elevator_west_info2.a('floor', '06');
                data.p3(695, currentY + direction * speed, 2772);
                if (direction === 1) {
                  _this.g3d.dm().removeScheduleTask(elevatorTask_l);
                  speed = 0;
                  setTimeout(function () {
                    speed = 2;
                    data.p3(695, currentY + direction * speed, 2772);
                    _this.g3d.dm().addScheduleTask(elevatorTask_l);
                  }, 2000)
                }
              } else if (Math.abs(currentY) === 944.16172) {
                this.floor_l = 7;
                elevator_west_info.a('floor', '07');
                elevator_west_info2.a('floor', '07');
                data.p3(695, currentY + direction * speed, 2772);
              } else if (Math.abs(currentY) === 986.16172) {
                this.floor_l = 8;
                elevator_west_info.a('floor', '08');
                elevator_west_info2.a('floor', '08');
                data.p3(695, currentY + direction * speed, 2772);
                if (direction === 1) {
                  _this.g3d.dm().removeScheduleTask(elevatorTask_l);
                  speed = 0;
                  setTimeout(function () {
                    speed = 2;
                    direction_l = -1;
                    data.p3(695, currentY + direction * speed, 2772);
                    _this.g3d.dm().addScheduleTask(elevatorTask_l);
                  }, 2000)
                }
              } else if (Math.abs(currentY) === 686.16172) {
                _this.g3d.dm().removeScheduleTask(elevatorTask_l);
                speed = 0;
                this.floor_l = 1;
                elevator_west_info.a('floor', '01');
                elevator_west_info2.a('floor', '01');
                setTimeout(function () {
                  speed = 2;
                  direction_l = 1;
                  data.p3(695, currentY + direction * speed, 2772);
                  _this.g3d.dm().addScheduleTask(elevatorTask_l);
                }, 2000)
              } else {
                data.p3(695, currentY + direction * speed, 2772);
              }
            }
          }
        }
      };
      let elevatorTask_r = {
        interval: 50,
        action: (data) => {
          let speed = 2;
          if (data === elevator_east) {
            let currentY = data.p3()[1], direction = direction_r;
            let speed = 2;
            let position_right = [935 + width / 2, currentY, 2688];
            elevator_east_info.p3(position_right);
            elevator_east_info2.p3(position_right);
            if (Math.abs(currentY) <= 990) {
              // 左侧电梯的运行动画
              if (Math.abs(currentY) === 754) {
                this.floor_r = 2;
                elevator_east_info.a('floor', '02');
                elevator_east_info2.a('floor', '02');
                data.p3(1285, currentY + direction * speed, 2746);
              } else if (Math.abs(currentY) === 794) {
                this.floor_r = 3;
                elevator_east_info.a('floor', '03');
                elevator_east_info2.a('floor', '03');
                data.p3(1285, currentY + direction * speed, 2746);
                if (direction_r === 1) {
                  _this.g3d.dm().removeScheduleTask(elevatorTask_r);
                  setTimeout(function () {
                    speed = 2;
                    data.p3(1285, currentY + direction * speed, 2746);
                    _this.g3d.dm().addScheduleTask(elevatorTask_r);
                  }, 2000)
                }
              } else if (Math.abs(currentY) === 834) {
                this.floor_r = 4;
                elevator_east_info.a('floor', '04');
                elevator_east_info2.a('floor', '04');
                data.p3(1285, currentY + direction * speed, 2746);
              } else if (Math.abs(currentY) === 874) {
                this.floor_r = 5;
                elevator_east_info.a('floor', '05');
                elevator_east_info2.a('floor', '05');
                data.p3(1285, currentY + direction * speed, 2746);
              } else if (Math.abs(currentY) === 910) {
                this.floor_r = 6;
                elevator_east_info.a('floor', '06');
                elevator_east_info2.a('floor', '06');
                data.p3(1285, currentY + direction * speed, 2746);
              } else if (Math.abs(currentY) === 944) {
                this.floor_r = 7;
                elevator_east_info.a('floor', '07');
                elevator_east_info2.a('floor', '07');
                data.p3(1285, currentY + direction * speed, 2746);
              } else if (Math.abs(currentY) === 986) {
                this.floor_r = 8;
                elevator_east_info.a('floor', '08');
                elevator_east_info2.a('floor', '08');
                data.p3(1285, currentY + direction * speed, 2746);
                if (direction === 1) {
                  _this.g3d.dm().removeScheduleTask(elevatorTask_r);
                  speed = 0;
                  setTimeout(function () {
                    speed = 2;
                    direction_r = -1;
                    data.p3(1285, currentY + direction * speed, 2746);
                    _this.g3d.dm().addScheduleTask(elevatorTask_r);
                  }, 2000)
                }

              } else if (Math.abs(currentY) === 686) {
                _this.g3d.dm().removeScheduleTask(elevatorTask_r);
                speed = 0;
                this.floor_r = 1;
                elevator_east_info.a('floor', '01');
                elevator_east_info2.a('floor', '01');
                setTimeout(function () {
                  speed = 2;
                  direction_r = 1;
                  data.p3(1285, currentY + direction * speed, 2746);
                  _this.g3d.dm().addScheduleTask(elevatorTask_r);
                }, 2000)
              } else {
                data.p3(1285, currentY + direction * speed, 2746);
              }
              for (let i = 1; i <= 8; i++) {
                let floor = this.g3d.dm().getDataByTag("floor" + i);
                if (i === this.floor_r || i === this.floor_l) {
                  floor.s('brightness', 1.2);
                  floor.s('shape3d.top.color', 'rgb(184,109,11)');
                } else {
                  floor.s('brightness', 0.7);
                  floor.s('shape3d.top.color', 'rgb(51,153,255)');
                }
              }
            }
          }
        }
      };
      this.elevatorTask_l = elevatorTask_l;
      this.elevatorTask_r = elevatorTask_r;
      this.g3d.dm().addScheduleTask(elevatorTask_l);
      this.g3d.dm().addScheduleTask(elevatorTask_r);
    },
    //小车
    startMetroAnimate(path) {
      let _this = this;
      let right_bar = this.g3d.dm().getDataByTag("摇杆-r"),
          left_bar = this.g3d.dm().getDataByTag("摇杆-l"),
          rightMetro = this.g3d.dm().getDataByTag('car-in'),
          leftMetro = this.g3d.dm().getDataByTag('car-out'),
          right,
          left;
      if (path === 'right') {
        right = rightMetro;
        rightMetro.a('direction', -1);
        right.setX(2864);
        right_bar.setRotationZ(0);
      } else if (path === 'left') {
        left = leftMetro;
        left_bar.setRotationZ(0);
        leftMetro.a('direction', 1);
        left.setX(2347);
      } else if (path === 'both') {
        left = leftMetro;
        right = rightMetro;
        left_bar.setRotationZ(0);
        leftMetro.a('direction', 1);
        right_bar.setRotationZ(0);
        rightMetro.a('direction', -1);
        right.setX(2864);
        left.setX(2347);
        right.setY(2244);
        left.setY(2360);
      }
      let metroTask1 = {
        interval: 50,
        action: (data) => {
          if (data === right) {
            let currentX = data.getX(), direction = data.a('direction');
            let currentZ = data.getY();
            let speed = this.getSpeedByX(currentX);
            let opacity = this.getOpacityByX(currentX, direction);
            if (Math.abs(currentX) >= 1800) {
              // 三元表达式中 transparent 为 false 时，小车会变黑。但是单独使用时没事 ==== 小车模型的问题（透明无，透明度也为0时，小车全黑）
              opacity !== 1 ? right.s({'shape3d.transparent': true, 'shape3d.opacity': opacity}) :
                  right.s({'shape3d.transparent': false});
              // 小车通过栏杆时 抬杆动画
              if (Math.abs(currentX) === 2792) {
                _this.g3d.dm().removeScheduleTask(_this.metro_task1);
                speed = 0;
                data.setX(currentX + direction * speed);
                ht.Default.startAnim({
                  duration: 2000,
                  easing: function (e) {
                    return e
                  },
                  finishFunc: function () {
                    speed = _this.getSpeedByX(currentX);
                    data.setX(currentX + direction * speed);
                    _this.g3d.dm().addScheduleTask(_this.metro_task1);
                  },
                  action: function (e) {
                    let angle = 75 * (Math.PI / 180);
                    right_bar.setRotationZ(-angle * e);
                  }
                });
              } else if (Math.abs(currentX) === 2612) {
                data.setX(currentX + direction * speed);
                _this.g3d.dm().addScheduleTask(_this.metro_task1);
                ht.Default.startAnim({
                  duration: 2000,
                  easing: function (e) {
                    return e
                  },
                  finishFunc: function () {
                  },
                  action: function (e) {
                    let angle = 75 * (Math.PI / 180);
                    right_bar.setRotationZ(-angle + angle * e);
                  }
                });
              } else {
                data.setX(currentX + direction * speed);
                data.setY(currentZ - direction)
              }
            }
            // 右面小车开到头
            let car_info1 = this.g3d.dm().getDataByTag("car-info1");
            if (currentX < 1950 && direction === -1) {
              car_info1.s('3d.visible', false);
              this.g3d.dm().removeScheduleTask(metroTask1);
            }
            // 小车通过车辆入口时显示板
            if (currentX <= 2790 && currentX > 1950) {
              setVisible(car_info1, true);
              car_info1.p3(2741, 696, 2250);
              car_info1.a('clip1', 1);
              this.repeatAnim();
            } else {
              car_info1.a('clip1', 0)
            }
          }
        }
      };
      let metroTask2 = {
        interval: 50,
        action: (data) => {
          if (data === left) {
            let currentX = data.getX(), direction = data.a('direction');
            let currentZ = data.getY();
            let speed = this.getSpeedByX(currentX);
            let opacity = this.getOpacityByX(currentX, direction);
            if (Math.abs(currentX) <= 3200) {
              // 三元表达式中 transparent 为 false 时，小车会变黑。但是单独使用时没事 ==== 小车模型的问题（透明无，透明度也为0时，小车全黑）
              opacity !== 1 ? left.s({'shape3d.transparent': true, 'shape3d.opacity': opacity}) :
                  left.s({'shape3d.transparent': false});
              // 小车通过栏杆时 抬杆动画
              if (Math.abs(currentX) === 2705) {
                _this.g3d.dm().removeScheduleTask(_this.metro_task2);
                speed = 0;
                data.setX(currentX + direction * speed);
                ht.Default.startAnim({
                  duration: 2000,
                  easing: function (e) {
                    return e
                  },
                  finishFunc: function () {
                    speed = _this.getSpeedByX(currentX);
                    data.setX(currentX + direction * speed);
                    _this.g3d.dm().addScheduleTask(_this.metro_task2);
                  },
                  action: function (e) {
                    let angle = 75 * (Math.PI / 180);
                    left_bar.setRotationZ(-angle * e);
                  }
                });
              } else if (Math.abs(currentX) === 2808) {
                data.setX(currentX + direction * speed);
                _this.g3d.dm().addScheduleTask(_this.metro_task2);
                ht.Default.startAnim({
                  duration: 2000,
                  easing: function (e) {
                    return e
                  },
                  finishFunc: function () {
                  },
                  action: function (e) {
                    let angle = 75 * (Math.PI / 180);
                    left_bar.setRotationZ(-angle + angle * e);
                  }
                });
              } else {
                data.setX(currentX + direction * speed);
                data.setY(currentZ - direction)
              }
            }
            // 左面小车开到头
            let car_info2 = this.g3d.dm().getDataByTag("car-info2");
            if (currentX > 3200 && direction === 1) {
              car_info2.s('3d.visible', false);
              this.g3d.dm().removeScheduleTask(metroTask2);
            }
            // 小车通过车辆入口时显示板
            if (currentX >= 2710 && currentX < 3200) {
              setVisible(car_info2, true);
              car_info2.p3(2751, 660, 2360);
              car_info2.a('clip1', 1);
              this.repeatAnim();
            } else {
              car_info2.a('clip1', 0)
            }
          }
        }
      };
      this.metro_task1 = metroTask1;
      this.metro_task2 = metroTask2;
      if (this.car_moving) {
        this.g3d.dm().addScheduleTask(metroTask1);
        this.g3d.dm().addScheduleTask(metroTask2);
      } else {
        this.g3d.dm().removeScheduleTask(metroTask1);
        this.g3d.dm().removeScheduleTask(metroTask2);
      }

    },
    getSpeedByX(x) {
      let absX = Math.abs(x);
      let speed = Math.ceil(absX / 250);
      if (speed > 10) {
        return speed;
      } else if (absX >= 10) {
        return 10;
      } else {
        return 0;
      }
    },
    getOpacityByX(x, direction) {
      let absX = Math.abs(x);
      if (direction === -1) {
        if (absX < 2000 && absX >= 1800) return 0;
        if (absX < 2100 && absX >= 2000) return 0.2;
        if (absX < 2200 && absX >= 2100) return 0.4;
        if (absX < 2300 && absX >= 2200) return 0.5;
        if (absX < 2400 && absX >= 2300) return 0.6;
        if (absX < 2500 && absX >= 2400) return 0.7;
        if (absX < 2600 && absX >= 2500) return 0.8;
        if (absX < 2800 && absX >= 2600) return 0.9;
        if (absX >= 2800) return 0.99;
      } else if (direction === 1) {
        if (absX > 3150) return 0;
        if (absX < 3150 && absX >= 3100) return 0.2;
        if (absX < 3100 && absX >= 3050) return 0.4;
        if (absX < 3050 && absX >= 3000) return 0.5;
        if (absX < 3000 && absX >= 2900) return 0.6;
        if (absX < 2900 && absX >= 2800) return 0.7;
        if (absX < 2800 && absX >= 2700) return 0.8;
        if (absX < 2700 && absX >= 2600) return 0.9;
        if (absX <= 2600) return 0.99;
      }
    },
    // 移除数组的某项
    arrayRemove(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          arr.splice(i, 1);
          return arr;
        }
      }
    },
    //建筑信息
    monitorBtn(internalsInfo) {
      this.g3d.addInteractorListener(e => {
        if (this.rotate_flag && e.kind === 'clickBackground') {
          this.rotate_anim ? this.rotate_anim.stop(true) : null;
          this.rotate_flag = false;
        }
        this.internalsName = [];
        let is_right_button = ht.Default.isRightButton(e.event);
        if (!is_right_button) {
          for (let i = 0; i < internalsInfo.name.length; i++) {
            this.internalsName.push(internalsInfo.name[i])
          }
          if (e.kind === 'clickData') {
            const node = e.data;
            const _tag = node._tag;
            const isIinternals = internalsInfo.name.some(item => item === node._displayName);
            const isBuildings = internalsInfo.name.some(item => item === 'D座');
            if (isBuildings) {
              for (let i = 0; i < this.internalsName.length; i++) {
                let building = this.g3d.dm().getDataByTag(this.internalsName[i]);
                building.s('brightness', 1);
              }
              if (node) {
                node.s('select.brightness', 1.3) //设置节点选中亮度
              }
            }

            // 路由跳转
            if (_tag === "D座配电室墙体") {
              this.$router.push('/eleDistributionRoom1');
            } else if (_tag === "自如寓配电室") {
              this.$router.push('/eleDistributionRoom');
            } else if (_tag === "光伏集装箱") {
              this.$router.push('/pvProfile');
            } else if (_tag === "meeting_room") {
              this.$router.push('/conferenceRoom');
            }

            // 有权限的节点
            if (isIinternals) {
              const info1 = this.g3d.dm().getDataByTag('info1');
              const info2 = this.g3d.dm().getDataByTag('info2');
              let car_info1 = this.g3d.dm().getDataByTag("car-info1");
              let car_info2 = this.g3d.dm().getDataByTag("car-info2");
              let posi = node.p3()

              if (this.metro_task1 !== null) {
                this.metro_task1.enabled = false;
              }
              if (this.metro_task2 !== null) {
                this.metro_task2.enabled = false;
              }

              if (isBuildings) {
                const internalsDark = this.arrayRemove(this.internalsName, node);
                for (let i = 0; i < internalsDark.length; i++) {
                  let building = this.g3d.dm().getDataByTag(internalsDark[i]);
                  building.s('brightness', 0.7);
                }

                // 更改 建筑面板 高度
                const dm = this.g3d.dm()
                var height = node.getTall();
                posi[1] += height;

                // 利用获取到的 displayName 取到当前的属性名字
                let internalsNode
                for (let i in internalsInfo) {
                  if (internalsInfo[i].tag && internalsInfo[i].tag === node.getTag()) {
                    internalsNode = internalsInfo[i]
                    break
                  }
                }
                car_info1.s('3d.visible', false)
                car_info2.s('3d.visible', false)
                info1.s('3d.visible', false)
                info2.s('3d.visible', false)
                // info1.s('3d.visible', true)
                // info2.s('3d.visible', true)
                // info1.p3(posi)
                // info2.p3(posi)

                const infoText = `${internalsNode['infoText']}`;
                const devIndex = [
                  {name: 'A/B座', waterConsumption: 0.6},
                  {name: 'D座', waterConsumption: 1.0},
                  {name: 'G座/E座', waterConsumption: 0.8},
                  {name: 'F座', waterConsumption: 0.9},
                  {name: '网二公寓', waterConsumption: 1.7},
                  {name: '8号楼', waterConsumption: 1.7},
                  {name: '9号楼', waterConsumption: 1.3},
                  {name: '10号楼', waterConsumption: 1.5},
                  {name: '辣尚瘾', waterConsumption: 1.6},
                  {name: '自如寓', waterConsumption: 1.4},
                  {name: '龙福宫', waterConsumption: 1.52},
                  {name: '光伏集装箱', waterConsumption: 0},
                ]

                const clipIndex = devIndex.findIndex(item => item.name === infoText)

                for (let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
                  info1.a(`clip${i}`, 0)
                  info2.a(`clip${i}`, 0)
                }
                info1.a(`clip${clipIndex + 1}`, 1)
                info2.a(`clip${clipIndex + 1}`, 1)
                for (let item of this.currentDataValueArr) {
                  if (infoText.indexOf(item.categoryTitle) !== -1) {
                    info1.a({
                      'WokingTemperature': item.currentDateValue,
                      'staticTemperature': (devIndex[clipIndex].waterConsumption / 24 * new Date().getHours()).toFixed(2),
                      'CutOutSpeed': item.categoryRatetoall,
                      'rotateSpeed': item.circularRate
                    })
                    info2.a({
                      'WokingTemperature': item.currentDateValue,
                      'staticTemperature': (devIndex[clipIndex].waterConsumption / 24 * new Date().getHours()).toFixed(2),
                      'CutOutSpeed': item.categoryRatetoall,
                      'rotateSpeed': item.circularRate
                    })
                    info1.s('3d.visible', true)
                    info2.s('3d.visible', true)
                    info1.p3(posi)
                    info2.p3(posi)
                  }
                }
                // 对面板修改属性
                info1.a({
                  // 'infoImage': internalsNode['infoImage'],
                  'infoText': `${infoText}`,
                  'translateText': internalsNode['translateText'],
                })
                info2.a({
                  // 'infoImage': internalsNode['infoImage'],
                  'infoText': `${infoText}`,
                  'translateText': internalsNode['translateText'],
                })
              }
            }
          }
        }
      })
    },
    environmentMonitor() {
      this.repeatAnim();
      let env_info1 = this.g3d.dm().getDataByTag("env-info1");
      let node1 = this.g3d.dm().getDataByTag('A/B座');
      let posi1 = node1.p3();
      env_info1.s('3d.visible', true);
      env_info1.p3(posi1);

      let env_info2 = this.g3d.dm().getDataByTag("env-info2");
      let node2 = this.g3d.dm().getDataByTag('G座/E座');
      let posi2 = node2.p3();
      env_info2.s('3d.visible', true);
      env_info2.p3(posi2);

      let env_info3 = this.g3d.dm().getDataByTag("env-info3");
      let node3 = this.g3d.dm().getDataByTag('F座');
      let posi3 = node3.p3();
      env_info3.s('3d.visible', true);
      env_info3.p3(posi3);

      let env_info4 = this.g3d.dm().getDataByTag("env-info4");
      let node4 = this.g3d.dm().getDataByTag('D座');
      let posi4 = node4.p3();
      env_info4.s('3d.visible', true);
      env_info4.p3(posi4);

      let internalsInfo = ['A/B座', 'D座', 'G座/E座', 'F座', '网二公寓', '8号楼', '9号楼', '10号楼', '辣尚瘾', '自如寓', '龙福宫', '光伏集装箱', '网二西侧平房', '网二公寓西侧三层', '海友商店', '永隆汽车', '金渝川菜', '门楼']
      for (let i = 0; i < internalsInfo.length; i++) {
        this.internalsName_env.push(internalsInfo[i]);
      }
      for (let i = 0; i < this.internalsName_env.length; i++) {
        let building = this.g3d.dm().getDataByTag(this.internalsName_env[i]);
        building.s('brightness', 1.3);
      }
      this.arrayRemove(internalsInfo, node1);
      this.arrayRemove(internalsInfo, node2);
      this.arrayRemove(internalsInfo, node3);
      this.arrayRemove(internalsInfo, node4);
      for (let i = 0; i < internalsInfo.length; i++) {
        let building = this.g3d.dm().getDataByTag(internalsInfo[i]);
        building.s('brightness', 0.7);
      }
    },
    move(e) {
      let odiv = e.target;// 获取目标元素
      let close_btn = document.querySelector('.videoDetails-warp span');
      //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
      let x = e.clientX - odiv.offsetLeft;
      let y = e.clientY - odiv.offsetTop;
      document.onmousemove = (e) => {
        // 获取拖拽元素的位置
        let left = e.clientX - x;
        let top = e.clientY - y;
        this.positionX = left;
        this.positionY = top;
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      }
      // 为了防止 火狐浏览器 拖拽阴影问题
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null
      }
    },
    closeVideo() {
      document.querySelector('.camera-wrap').style.cssText = 'display:none';
    },
    //综合概况
    integratedManagement() {
      let buildingD = this.g3d.dm().getDataByTag("D座");
      let info1 = this.g3d.dm().getDataByTag("info1");
      let info2 = this.g3d.dm().getDataByTag("info2");

      info1.s('3d.visible', true)
      info2.s('3d.visible', true)
      let posi = buildingD.p3();
      let height = buildingD.getTall();
      posi[1] += height;
      info1.p3(posi);
      info2.p3(posi);
      let infoText = 'D座';
      let translateText = 'Building management';
      for (let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
        info1.a(`clip${i}`, 0)
        info2.a(`clip${i}`, 0)
      }
      info1.a('clip2', 1)
      info2.a('clip2', 1)
      // 对面板修改属性
      info1.a({
        'infoText': infoText,
        'translateText': translateText,
        'WokingTemperature': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].currentDateValue : '',
        'staticTemperature': (1.00 / 24 * new Date().getHours()).toFixed(2),
        'CutOutSpeed': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].categoryRatetoall : '',
        'rotateSpeed': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].circularRate : ''
      });
      info2.a({
        'infoText': infoText,
        'translateText': translateText,
        'WokingTemperature': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].currentDateValue : '',
        'staticTemperature': (1.00 / 24 * new Date().getHours()).toFixed(2),
        'CutOutSpeed': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].categoryRatetoall : '',
        'rotateSpeed': this.currentDataValueArr.length !== 0 ? this.currentDataValueArr[3].circularRate : ''
      });
      // this.repeatAnim();
      let internalsInfo = {
        name: ['A/B座', 'D座', 'G座/E座', 'F座', '网二公寓', '8号楼', '9号楼', '10号楼', '辣尚瘾', '自如寓', '龙福宫', '光伏集装箱', '网二西侧平房', '网二公寓西侧三层', '海友商店', '永隆汽车', '金渝川菜', '门楼'],
        buildingAB: {
          index: 1,
          infoText: 'A/B座',
          tag: 'A/B座',
          translateText: 'Building management'
        },
        buildingD: {
          index: 2,
          infoText: 'D座',
          tag: 'D座',
          translateText: 'Building management'
        },
        buildingGE: {
          index: 3,
          infoText: 'G座/E座',
          tag: 'G座/E座',
          translateText: 'Building management'
        },
        buildingF: {
          index: 4,
          infoText: 'F座',
          tag: 'F座',
          translateText: 'Building management'
        },
        buildingw2: {
          index: 5,
          infoText: '网二公寓',
          tag: '网二公寓',
          translateText: 'Building management'
        },
        building8: {
          index: 6,
          infoText: '8号楼',
          tag: '8号楼',
          translateText: 'Building management'
        },
        building9: {
          index: 7,
          infoText: '9号楼',
          tag: '9号楼',
          translateText: 'Building management'
        },
        building10: {
          index: 8,
          infoText: '10号楼',
          tag: '10号楼',
          translateText: 'Building management'
        },
        buildinglsy: {
          index: 9,
          infoText: '辣尚瘾',
          tag: '辣尚瘾',
          translateText: 'Building management'
        },
        buildingzyy: {
          index: 10,
          infoText: '自如寓',
          tag: '自如寓',
          translateText: 'Building management'
        },
        buildinglfg: {
          index: 11,
          infoText: '龙福宫',
          tag: '龙福宫',
          translateText: 'Building management'
        },
        buildinggf: {
          index: 12,
          infoText: '光伏集装箱',
          tag: '光伏集装箱',
          translateText: 'Building management'
        },
      };
      this.monitorBtn(internalsInfo);
    },
    // 停车管理按钮
    parkingManage() {
      let parking2 = this.g3d.dm().getDataByTag("停车场2");
      let parking1 = this.g3d.dm().getDataByTag("停车场1");
      let info1 = this.g3d.dm().getDataByTag("info1");
      let info2 = this.g3d.dm().getDataByTag("info2");
      let parking_info1 = this.g3d.dm().getDataByTag("parking-info1");
      let parking_info2 = this.g3d.dm().getDataByTag("parking-info2");
      this.repeatAnim();
      this.$get('generalsituation/getremainingspace').then((response) => {
        parking_info1.a('parking_name1', response[0].name);
        parking_info1.a('capacity1', response[0].capacity);
        parking_info1.a('remaining_space1', response[0].remainingspace);
        parking_info2.a('parking_name2', response[1].name);
        parking_info2.a('capacity2', response[1].capacity);
        parking_info2.a('remaining_space2', response[1].remainingspace);
      })
      setVisible(info1, false);
      setVisible(info2, false);
      setVisible(parking_info1, true);
      setVisible(parking_info2, true);
      parking_info1.p3(parking1.p3());
      parking_info2.p3(parking2.p3());
      let infoText = '停车管理';
      let translateText = 'Parking management';
      parking_info1.a('clip1', 1)
      parking_info2.a('clip2', 1)
      // 对面板修改属性
      parking_info1.a({
        'infoText': infoText,
        'translateText': translateText,
      });
      parking_info2.a({
        'infoText': infoText,
        'translateText': translateText,
      });
      this.repeatAnim();
      // let internalsInfo = {
      //   name: ['停车场1', '停车场2'],
      //   parking1: {
      //     index: 13,
      //     infoText: '停车场1',
      //     tag: '停车场1',
      //     translateText: 'Parking management'
      //   },
      //   parking2: {
      //     index: 14,
      //     infoText: '停车场2',
      //     tag: '停车场2',
      //     translateText: 'Parking management'
      //   }
      // };
      // this.monitorBtn(internalsInfo);
    },
    //运维中心-报警管理
    showAlarmPanel(action) {
      let alarm_arr = ['fire-info1', 'fire-info2', 'pv-info1', 'pv-info2', 'alarm1', 'default_scale_red'];
      for (let i in alarm_arr) {
        let now_dm = this.g3d.dm().getDataByTag(alarm_arr[i]);
        if (action == 'show') {
          setVisible(now_dm, true);
        } else {
          setVisible(now_dm, false);
        }

      }
    },
    alarmManagement() {
      let buildingD = this.g3d.dm().getDataByTag("D座");
      let buildingNight = this.g3d.dm().getDataByTag("9号楼");
      let info1 = this.g3d.dm().getDataByTag("fire-info1");
      let info2 = this.g3d.dm().getDataByTag("fire-info2");
      let pv_info1 = this.g3d.dm().getDataByTag("pv-info1");
      let pv_info2 = this.g3d.dm().getDataByTag("pv-info2");
      let alarm1 = this.g3d.dm().getDataByTag("alarm1");
      let alarm2 = this.g3d.dm().getDataByTag("default_scale_red");
      let height1 = buildingD.getTall();//获取建筑高度
      let height2 = buildingNight.getTall();
      let posi_fire = buildingNight.p3()
      posi_fire[1] = height2 + posi_fire[1] + 100;//y轴加建筑高度
      let alarmTagArr = [];
      this.$get('generalsituation/getphotovoltaiccameraalarmdata')
          .then((response) => {
            if (response.camera.length !== 0) {
              this.fire_alarm = response.camera[0].alarmDescription;
              this.fire_time = response.camera[0].createdAt;
              this.fire_value = response.camera[0].alarmValue;
              this.fire_location = this.rootUrl + response.camera[0].alarmImageUri;

              info1.p3(posi_fire);
              info2.p3(posi_fire);
              info1.a('time', this.fire_time);
              info2.a('time', this.fire_time);
              info1.a('value', this.fire_value);
              info2.a('value', this.fire_value);
              info1.a('location', this.fire_alarm);
              info2.a('location', this.fire_alarm);
              info1.a('picture', this.fire_location);
              info2.a('picture', this.fire_location);
              for (let i of [1]) {
                info1.a(`clip${i}`, 0)
                info2.a(`clip${i}`, 0)
              }
              info1.a('clip1', 1)
              info2.a('clip1', 1)
              setVisible(info1, true);
              setVisible(info2, true);
              setVisible(alarm1, true);
              alarmTagArr.push('alarm1');
            }
            if (response.photovoltaic.length !== 0) {
              this.pv_time = response.photovoltaic[0].createdAt;
              this.pv_value = response.photovoltaic[0].alarmValue;
              this.pv_location = response.photovoltaic[0].alarmDescription;

              let posi_pv = buildingD.p3()
              posi_pv[1] = height1 + posi_pv[1] + 20;
              pv_info1.p3(posi_pv);
              pv_info2.p3(posi_pv);
              pv_info1.a('time', this.pv_time);
              pv_info2.a('time', this.pv_time);
              pv_info1.a('value', this.pv_value);
              pv_info2.a('value', this.pv_value);
              pv_info1.a('location', this.pv_location);
              pv_info2.a('location', this.pv_location);
              for (let i of [1]) {
                pv_info1.a(`clip${i}`, 0)
                pv_info2.a(`clip${i}`, 0)
              }
              pv_info1.a('clip1', 1)
              pv_info2.a('clip1', 1)
              setVisible(pv_info1, true);
              setVisible(pv_info2, true);
              setVisible(alarm2, true);
              alarmTagArr.push('default_scale_red');
            }
            this.setDefault(alarmTagArr);
          })
          .catch((response) => {
          })
    },
    updatePeopleinfo() {
      let people_info = this.g3d.dm().getDataByTag("people-info");
      let people_info2 = this.g3d.dm().getDataByTag("people-info2");
      this.$get('generalsituation/getlastdoorrecordlist', ['1502,1503', 0]).then((response) => {
        let record = 'doorRecordLastJieLink:200790528';
        let peron1Data = response[record];
        this.personInfo1Status = false;
        if (peron1Data.length != 0) {
          this.personInfo1Status = true;
          people_info.a('name', peron1Data.person.personName);
          people_info.a('date', peron1Data.crossTime);
          people_info.a('picture', peron1Data.person.personPhoto);
          people_info.a('temperature', peron1Data.temperature);
          people_info.a('clip1', 1);
        }
        let record2 = 'doorRecordLastJieLink:195103232';
        let peron2Data = response[record2];
        this.personInfo2Status = false;
        if (peron2Data.length != 0) {
          this.personInfo2Status = true;
          people_info2.a('name', response[record2].person.personName);
          people_info2.a('date', response[record2].crossTime);
          people_info2.a('picture', response[record2].person.personPhoto);
          people_info2.a('temperature', response[record2].temperature);
          people_info2.a('clip1', 1)
        }
      })
      return this.updatePeopleinfo;
    },
    // 人员进出
    personnelAccess() {
      this.updatePeopleinfo()
      let _this = this;
      this.timer3 = setInterval(
          _this.updatePeopleinfo()
          , 5000);
    },
    // 复位视角
    resetPerspective() {
      this.g3d.setEye(1765, 2624, 154);
      this.g3d.setCenter(1342, 235, 2547);
    },
    // 隐藏/显示建筑
    transformBuilding(action) {
      let buildingD = this.g3d.dm().getDataByTag("D座");
      let buildingZRY = this.g3d.dm().getDataByTag("自如寓");
      let hide_room = this.dm.getDataByTag("hidebuild");
      let cameras = this.g3d.dm().getDataByTag('cameras');
      let cameras_name = cameras.getChildren()._as;
      if (action === "hide") {
        hide_room.a("hidetext", "显示建筑");
        buildingD.s('3d.visible', false);
        buildingZRY.s('3d.visible', false);
        for (let i = 0; i < cameras_name.length; i++) {
          let camera = this.g3d.dm().getDataByTag(cameras_name[i]._tag);
          camera.s('3d.visible', false);
        }
        this.hide_building = false;
      } else if (action === "show") {
        hide_room.a("hidetext", "隐藏建筑");
        buildingD.s('3d.visible', true);
        buildingZRY.s('3d.visible', true);
        for (let i = 0; i < cameras_name.length; i++) {
          let camera = this.g3d.dm().getDataByTag(cameras_name[i]._tag);
          camera.s('3d.visible', true);
        }
        this.hide_building = true;
      }
    },
    //重新按钮监听
    buttonMonitor(e) {
      let _this = this;
      const {kind, data} = e; // 事件类型
      let px = [532, 609, 690, 767, 845, 923, 1001, 1076];
      let icon = this.graphView.dm().getDataByTag("buttonHoverIcon");
      const enter_buttons = ["energy", "building", "office", "property", "environment", "security", "operation", "interface", "back", "hidebtn", "water", "elec", "photovoltaic", "elevator", "light", "air_conditioning", "meeting", "parking", "people", "video", "access", "alarm", 'power', 'hidebtn', 'reset', 'rotate', 'escape', 'hidebuild'];
      const small_buttons = ["water", "elec", "photovoltaic", "elevator", "light", "air_conditioning", "meeting", "parking", "people", "access", "video", "escape", "environment", "alarm", "power", "hidebtn", "reset", "rotate"];

      //建筑
      let buildingA = this.g3d.dm().getDataByTag("A/B座");
      let roofA = this.g3d.dm().getDataByTag("roof-A");
      let buildingD = this.g3d.dm().getDataByTag("D座");
      let buildingG = this.g3d.dm().getDataByTag("G座/E座");
      let buildingZRY = this.g3d.dm().getDataByTag("自如寓");

      //光伏
      let box = this.g3d.dm().getDataByTag('光伏集装箱');
      let cabinet = this.g3d.dm().getDataByTag('photovoltaic_cabinet');
      let cabinet_title = this.g3d.dm().getDataByTag('title_gfx');

      //配电管理
      let elec_building_arr = ['D座', '自如寓', 'F座', '海友商店', '辣尚瘾', '龙福宫', '门楼', '网二公寓', '网二公寓西侧三层', '网二西侧平房', '永隆汽车', 'A/B座', 'C座', '8号楼', '9号楼', '10号楼', '金渝川菜', 'G座/E座'];
      let ground1 = this.g3d.dm().getDataByTag("ground1");
      let hide_room = this.dm.getDataByTag("hidebuild");

      //获取按钮
      let water = this.dm.getDataByTag("water");
      let elec = this.dm.getDataByTag("elec");
      let photovoltaic = this.dm.getDataByTag("photovoltaic");
      let elevator = this.dm.getDataByTag("elevator");
      let light = this.dm.getDataByTag("light");
      let air_conditioning = this.dm.getDataByTag("air_conditioning");
      let meeting = this.dm.getDataByTag("meeting");
      let parking = this.dm.getDataByTag("parking");
      let people = this.dm.getDataByTag("people");
      let video = this.dm.getDataByTag("video");
      let access = this.dm.getDataByTag("access");
      let alarm = this.dm.getDataByTag("alarm");
      let power = this.dm.getDataByTag("power");
      let hidebtn = this.dm.getDataByTag("hidebtn");
      let reset = this.dm.getDataByTag("reset");
      let rotate = this.dm.getDataByTag("rotate");
      let escape = this.dm.getDataByTag("escape");
      let camera_table = this.dm.getDataByTag("camera-table");

      //面板信息
      let people_info = this.g3d.dm().getDataByTag("people-info");
      let people_info2 = this.g3d.dm().getDataByTag("people-info2");
      let parking_info1 = this.g3d.dm().getDataByTag("parking-info1");
      let parking_info2 = this.g3d.dm().getDataByTag("parking-info2");
      let elevator_west_info = this.g3d.dm().getDataByTag("ele-left-info");
      let elevator_east_info = this.g3d.dm().getDataByTag("ele-right-info");
      //报警管理

      for (let i = 0; i < this.internalsName.length; i++) {
        let building = this.g3d.dm().getDataByTag(this.internalsName[i]);
        building.s('brightness', 1);
      }

      //小车
      let car_info1 = this.g3d.dm().getDataByTag("car-info1");
      let car_info2 = this.g3d.dm().getDataByTag("car-info2");
      let car_in = this.g3d.dm().getDataByTag("car-in");
      let car_out = this.g3d.dm().getDataByTag("car-out");
      let right_bar = this.g3d.dm().getDataByTag("摇杆-r");
      let left_bar = this.g3d.dm().getDataByTag("摇杆-l");

      let water_road = this.g3d.dm().getDataByTag("water-path");
      let escape_road = this.g3d.dm().getDataByTag("escape-path");

      if (kind === "clickData") {
        let tag = data.getTag();
        if (small_buttons.indexOf(tag) > -1) {
          this.menu_index = small_buttons.indexOf(tag) <= 2 ? 0 :
              small_buttons.indexOf(tag) <= 5 ? 1 :
                  small_buttons.indexOf(tag) === 6 ? 2 :
                      small_buttons.indexOf(tag) <= 9 ? 3 :
                          small_buttons.indexOf(tag) <= 11 ? 4 :
                              small_buttons.indexOf(tag) === 12 ? 5 :
                                  small_buttons.indexOf(tag) <= 14 ? 6 :
                                      small_buttons.indexOf(tag) <= 17 ? 7 : 0;
          icon.setX(px[this.menu_index]);
        }
        // 返回按钮
        if (tag === "back") {
          this.$router.push('/eleRealTimeMonitoring');
        }

        if (tag === "hidebtn") {
          // var isHide = this.dm.getDataByTag("hidebtn");
          var isHide = this.dm.getDataByTag("hidetxt");
          var leftList = [],
              rightList = [];
          leftList.push(
              // this.dm.getDataByTag("leftBgc"),
              this.dm.getDataByTag("parkRun"),
              this.dm.getDataByTag("parkGeneral"),
              this.dm.getDataByTag("AIEquitment"));
          rightList.push(
              // this.dm.getDataByTag("rightBgc"),
              this.dm.getDataByTag("powerDetail"),
              this.dm.getDataByTag("lineblock"),
              this.dm.getDataByTag("pieblock"));
          if (_this.hide_flag === true) {
            isHide.s("text", "显示面板");
            leftList.forEach(i => {
              setVisible(i, false);
            });
            rightList.forEach(i => {
              setVisible(i, false);
            });
            _this.hide_flag = false;
          } else {
            isHide.s("text", "隐藏面板");
            leftList.forEach(i => {
              setVisible(i, true);
            });
            rightList.forEach(i => {
              setVisible(i, true);
            });
            _this.hide_flag = true;
          }
        } else if (tag === "camera-table") {  // 摄像头列表
          // 防止点击列表之后，各建筑样式改变
        } else if (tag === "hidebuild") {    // 隐藏建筑
          if (_this.hide_building === true) {
            this.transformBuilding('hide')
          } else {
            this.transformBuilding('show')
          }
        } else {
          //默认效果
          document.querySelector('.camera-wrap').style.cssText = 'display:none';
          setVisible(water_road, true);
          setVisible(escape_road, false);
          let cameras = this.g3d.dm().getDataByTag('cameras');
          let cameras_name = cameras.getChildren()._as;
          let cameras_view = this.g3d.dm().getDataByTag('cameras-view');
          let view_name = cameras_view.getChildren()._as;
          for (let i = 0; i < cameras_name.length; i++) {
            let camera = _this.g3d.dm().getDataByTag(cameras_name[i]._tag);
            let view = _this.g3d.dm().getDataByTag(view_name[i]._tag);
            camera.s('brightness', 0.7);
            setVisible(view, false);
          }
          this.transformBuilding('show')
          let elec_arr = [];
          for (let i = 1; i <= 13; i++) {
            let elec_road = "elec-path" + i,
                elec = this.g3d.dm().getDataByTag("elec-path" + i);
            elec_arr.push(elec_road);
            elec.s('3d.visible', false);
          }
          setOpacity(buildingA, true, 0.5);
          setVisible(roofA, true);
          this.rotate_anim ? this.rotate_anim.stop(true) : null;
          this.transition_anim ? this.transition_anim.pause() : null;
          people_info.s('3d.visible', false);
          people_info2.s('3d.visible', false);
          if (this.metro_task1 !== null) {
            this.metro_task1.enabled = false;
          }
          if (this.metro_task2 !== null) {
            this.metro_task2.enabled = false;
          }
          if (this.line_anim) {
            this.line_anim.stop(true);
          }
          car_in.s({'shape3d.transparent': true, 'shape3d.opacity': 0});
          car_out.s({'shape3d.transparent': true, 'shape3d.opacity': 0});
          right_bar.setRotationZ(0);
          left_bar.setRotationZ(0);
          car_info1.s('3d.visible', false);
          car_info2.s('3d.visible', false);
          this.showAlarmPanel('hide');
          parking_info1.s('3d.visible', false);
          parking_info2.s('3d.visible', false);
          buildingD.s({'shape3d.transparent': true, 'shape3d.opacity': 0.5});
          buildingD.setStyle('wf.color', 'rgba(89, 197, 227)');
          buildingG.s({'shape3d.transparent': true, 'shape3d.opacity': 0.5});
          buildingG.setStyle('wf.color', 'rgba(89, 197, 227)');
          box.s('3d.visible', true);
          cabinet.s('3d.visible', true);
          cabinet_title.s('3d.visible', true);
          buildingD.s('2d.selectable', true);
          buildingD.s('3d.selectable', true);
          buildingZRY.s('2d.selectable', true);
          buildingZRY.s('3d.selectable', true);
          camera_table.s('2d.visible', true);
          camera_table.s('2d.visible', false);
          hide_room.s('2d.visible', false);
          ground1.s('3d.visible', true);
          for (let i = 1; i <= 8; i++) {
            let floor = this.g3d.dm().getDataByTag("floor" + i);
            floor.s('3d.visible', false);
          }
          this.g3d.dm().removeScheduleTask(this.elevatorTask_l);
          this.g3d.dm().removeScheduleTask(this.elevatorTask_r);
          //环境监控
          for (let i = 0; i < this.internalsName_env.length; i++) {
            let building = this.g3d.dm().getDataByTag(this.internalsName_env[i]);
            building.s('brightness', 1);
          }
          this.showElevator('hide');
          this.showEnvPanels('hide');
          //光伏
          this.showPhotoLine('hide');
          //停车管理
          parking_info1.s('3d.visible', false);
          parking_info2.s('3d.visible', false);
          //按钮
          if (tag === "rotate") {  // 旋转

            if (this.rotate_flag) {
              this.rotate_anim ? this.rotate_anim.stop(true) : null;
              this.rotate_flag = false;
            } else {

              this.g3d.setEye(1483, 1574, 361);
              this.g3d.setCenter(1412, 535, 2165);
              rotateView(this);
              this.rotate_flag = true;
            }
          } else {
            this.rotate_flag = false;
            if (tag === "energy") {            //能源管理
              this.integratedManagement();
            } else if (tag === "water") {        //水流向
              transitionAnimation(this, [1174, 3147, 2125], [1177, 848, 2159], 4000)
              pathFlow(this, 'line_anim', ['water-path'], 50, 0.05, 'top.uv.offset', 'move');
            } else if (tag === "elec") {        //电流向
              transitionAnimation(this, [-94, 2642, 857], [816, 741, 2355], 4000)
              ground1.s('3d.visible', false);
              let elec_arr = [];
              for (let i = 1; i <= 13; i++) {
                let elec_road = "elec-path" + i,
                    elec = this.g3d.dm().getDataByTag("elec-path" + i);
                elec.s('3d.visible', true);
                elec_arr.push(elec_road);
              }
              pathFlow(this, 'line_anim', elec_arr, 20, 0.02, 'shape3d.uv.offset', 'move');
            } else if (tag === "photovoltaic") {       //光伏流向
              transitionAnimation(this, [152, 1730, 1677], [979, 728, 2744], 4000)
              this.showPhotoLine('show');
              pathFlow(this, 'line_anim', ['电路1', '电路2'], 30, 0.03, 'offset', 'move');
            } else if (tag === "meeting") {          //会议室
              transitionAnimation(this, [3329, 1506, 251], [869, 1075, 2478], 4000, function () {
                transitionAnimation(_this, [2448, 854, 2014], [2366, 741, 2121], 4000, function () {
                  transitionAnimation(_this, [2448, 854, 2014], [2366, 741, 2121], 4000)
                })
              })
              setOpacity(buildingA, true, 0.15);
              setVisible(roofA, false);
            } else if (tag === "parking") {      //停车管理
              transitionAnimation(this, [2249, 1897, 4653], [2579, 675, 2358], 4000)
              this.parkingManage();
            } else if (tag === "environment") {       //环境监测
              transitionAnimation(this, [1370, 3079, 4272], [1316, 534, 2007], 4000)
              this.environmentMonitor();
              this.showEnvPanels('show');
            } else if (tag === "people") {             //人员管理
              transitionAnimation(this, [3335, 820, 2170], [2809, 723, 2180], 4000)
              this.personnelAccess();


            } else if (tag === "access") {
              // console.log(2133213213);
              //车辆管理
              car_in.s('3d.visible', true);
              car_out.s('3d.visible', true);
              transitionAnimation(this, [3535, 1194, 2256], [1467, 7, 2380], 4000, function () {

                _this.car_moving = true;
                _this.side_flag = 'middle';
                _this.updateCarinfo();
              })
              this.onSearch()
              // transitionAnimation(this, [3324, 1102, 2349], [1202, 7, 2388],"access")
            } else if (tag === "alarm") {               //报警管理
              transitionAnimation(this, [2369, 1562, 4198], [2260, 675, 1755], 4000)
              this.alarmManagement();
              // this.showAlarmPanel('show');
            } else if (tag === "power") {             //配电管理
              transitionAnimation(this, [8, 919, 2666], [338, 217, 1836], 4000)
              for (let i in elec_building_arr) {
                let now = this.g3d.dm().getDataByTag(elec_building_arr[i]);
                now.s({'shape3d.transparent': true, 'shape3d.opacity': 0.1});
                now.setStyle('wf.color', 'rgba(89, 197, 227, 0.1)');
              }
              this.select_switchRoom = true;
              this.select_elec = true;
              buildingD.s('2d.selectable', false);
              buildingD.s('3d.selectable', false);
              buildingZRY.s('2d.selectable', false);
              buildingZRY.s('3d.selectable', false);
              hide_room.s('2d.visible', true);
              ground1.s('3d.visible', false);
              box.s('3d.visible', false);
              cabinet.s('3d.visible', false);
              cabinet_title.s('3d.visible', false);
              let elec_arr = [];
              for (let i = 1; i <= 13; i++) {
                let elec_road = "elec-path" + i,
                    elec = this.g3d.dm().getDataByTag("elec-path" + i);
                elec.s('3d.visible', true);
                elec_arr.push(elec_road);
              }
              pathFlow(this, 'line_anim', elec_arr, 20, 0.02, 'shape3d.uv.offset', 'move');
            } else if (tag === "reset") {
              this.resetPerspective();
            } else if (tag === "elevator") { //电梯

              transitionAnimation(this, [976, 1021, 3861], [898, 268, 751], 4000, function () {
                _this.showElevator('show');
                _this.elevatorAnimate();
              })
              let height = buildingD.getTall();
              let width = buildingD.getWidth() + 100;
              let position_left = [935 - width / 2, 676 + height / 2, 2688];
              elevator_west_info.p3(position_left);
              let position_right = [935 + width / 2, 676 + height / 2, 2688];
              elevator_east_info.p3(position_right);
              for (let i = 1; i <= 8; i++) {
                let floor = this.g3d.dm().getDataByTag("floor" + i);
                floor.s('3d.visible', true);
              }
              this.onSearch()
            } else if (tag === "video") {  // 视频监控
              let cameras_arr = ['D座电子楼大厅', 'D座电子楼正门（北）', '配电室、龙福宫南侧', 'D座电子楼北侧路（东）', 'D座电子楼东停车场', 'D座电子楼一层防火门', '配电室正门（西）', '锅炉房正门（西）'];
              let video_arr = ['080100003', '080100007', '080100008', '080100002', '080100001', '080100006', '080100004', '080100005'];
              transitionAnimation(this, [1338, 3376, 2337], [1333, 1075, 2275], 4000)
              // transitionAnimation(this, [1340, 4012, 2355], [1333, 1075, 2275])
              for (let i in elec_building_arr) {
                let now = this.g3d.dm().getDataByTag(elec_building_arr[i]);
                now.s({'shape3d.transparent': true, 'shape3d.opacity': 0.1});
                now.setStyle('wf.color', 'rgba(89, 197, 227, 0.1)');
              }
              ground1.s('3d.visible', false);
              videoMonitor(this, 'camera-table', 'cameras', 'cameras-view', cameras_arr, video_arr, 'generalsituation/index', '.camera-wrap');
              camera_table.s('2d.visible', true);
            } else if (tag === "escape") {  // 消防疏散
              transitionAnimation(this, [1040, 3364, 2412], [1026, 7, 2245], 4000);
              setVisible(water_road, false);
              setVisible(escape_road, true);
              pathFlow(this, 'line_anim', ['escape-path'], 50, -0.02, 'top.uv.offset', 'move');
            }
          }
        }
      } else if (kind === "onEnter") {
        let tag = data.getTag();
        if (enter_buttons.indexOf(tag) > -1) {
          this.graphView.getView().style.cursor = "pointer";
        }

        if (tag === "energy" || tag === "water" || tag === "elec" || tag === "photovoltaic") {
          setVisible(water, true);
          setVisible(elec, true);
          setVisible(photovoltaic, true);
          _this.water_flag = true;
        } else if (tag === "building" || tag === "elevator" || tag === "light" || tag === "air_conditioning") {
          setVisible(elevator, true);
          setVisible(light, true);
          setVisible(air_conditioning, true);
        } else if (tag === "office" || tag === "meeting") {
          setVisible(meeting, true);
        } else if (tag === "property" || tag === "parking" || tag === "people" || tag === "access") {
          setVisible(parking, true);
          setVisible(people, true);
          setVisible(access, true);
        } else if (tag === "security" || tag === "video" || tag === "escape") {
          setVisible(escape, true);
          setVisible(video, true);
        } else if (tag === "operation" || tag === "alarm" || tag === "power") {
          setVisible(alarm, true);
          setVisible(power, true);
        } else if (tag === "interface" || tag === "hidebtn" || tag === "reset" || tag === "rotate") {
          setVisible(hidebtn, true);
          setVisible(reset, true);
          setVisible(rotate, true);
        }
      } else if (kind === "onLeave") {
        let tag = data.getTag();
        if (enter_buttons.indexOf(tag) > -1) {
          this.graphView.getView().style.cursor = "default";
        }
        if (tag === "energy" || tag === "water" || tag === "elec" || tag === "photovoltaic") {
          setVisible(water, false);
          setVisible(elec, false);
          setVisible(photovoltaic, false);
          _this.water_flag = false;
        } else if (tag === "building" || tag === "elevator" || tag === "light" || tag === "air_conditioning") {
          setVisible(elevator, false);
          setVisible(light, false);
          setVisible(air_conditioning, false);
        } else if (tag === "office" || tag === "meeting") {
          setVisible(meeting, false);
        } else if (tag === "property" || tag === "parking" || tag === "people" || tag === "access") {
          setVisible(parking, false);
          setVisible(people, false);
          setVisible(access, false);
        } else if (tag === "security" || tag === "video" || tag === "escape") {
          setVisible(escape, false);
          setVisible(video, false);
        } else if (tag === "operation" || tag === "alarm" || tag === "power") {
          setVisible(alarm, false);
          setVisible(power, false);
        } else if (tag === "interface" || tag === "hidebtn" || tag === "reset" || tag === "rotate") {
          setVisible(hidebtn, false);
          setVisible(reset, false);
          setVisible(rotate, false);
        } else if (tag === "camera-table") {
          let cameras = this.g3d.dm().getDataByTag('cameras');
          let cameras_name = cameras.getChildren()._as;
          let cameras_view = this.g3d.dm().getDataByTag('cameras-view');
          let view_name = cameras_view.getChildren()._as;
          for (let i = 0; i < cameras_name.length; i++) {
            let camera = _this.g3d.dm().getDataByTag(cameras_name[i]._tag);
            let view = _this.g3d.dm().getDataByTag(view_name[i]._tag);
            camera.s('brightness', 0.7);
            setVisible(view, false);
          }
        }
      }
    },
    showPhotoLine(action) {
      let photovoltaic1 = this.g3d.dm().getDataByTag("电路1");
      let photovoltaic2 = this.g3d.dm().getDataByTag("电路2");
      let photovoltaic_arr = ['D座', '自如寓', 'F座', '海友商店', '辣尚瘾', '龙福宫', '门楼', '网二公寓', '网二公寓西侧三层', '网二西侧平房', '永隆汽车', 'A/B座', 'C座', '8号楼', '9号楼', '10号楼', '金渝川菜'];      //光伏操作的建筑
      for (let i in photovoltaic_arr) {
        let now = this.g3d.dm().getDataByTag(photovoltaic_arr[i]);
        if (action == 'show') {
          now.s({'shape3d.transparent': true, 'shape3d.opacity': 0.1});
          now.setStyle('wf.color', 'rgba(89, 197, 227, 0.1)');
        } else {
          now.s({'shape3d.transparent': true, 'shape3d.opacity': 0.5});
          now.setStyle('wf.color', 'rgba(89, 197, 227, 1)');
        }

      }
      if (action == 'show') {
        photovoltaic1.s('3d.visible', true);
        photovoltaic2.s('3d.visible', true);
      } else {
        photovoltaic1.s('3d.visible', false);
        photovoltaic2.s('3d.visible', false);
      }
    },
    showElevator(action) {
      let elevator_west = this.g3d.dm().getDataByTag("elevator-west");
      let elevator_east = this.g3d.dm().getDataByTag("elevator-east");
      let elevator_west_info = this.g3d.dm().getDataByTag("ele-left-info");
      let elevator_east_info = this.g3d.dm().getDataByTag("ele-right-info");
      let elevator_west_info2 = this.g3d.dm().getDataByTag("ele-left-info2");
      let elevator_east_info2 = this.g3d.dm().getDataByTag("ele-right-info2");
      let line_west = this.g3d.dm().getDataByTag("line-west");
      let line_east = this.g3d.dm().getDataByTag("line-east");
      let build_D = this.g3d.dm().getDataByTag("D座");
      let brands = this.g3d.dm().getDataByTag("名牌");
      let brands_name = brands.getChildren()._as;
      for (let i = 0; i < brands_name.length; i++) {
        let brand = this.g3d.dm().getDataByTag(brands_name[i]._tag);
        if (action == 'show') {
          setVisible(brand, false);
        } else {
          setVisible(brand, true);
        }
      }
      let build_arr = ['自如寓', 'F座', '海友商店', '辣尚瘾', '龙福宫', '门楼', '网二公寓', '网二公寓西侧三层', '网二西侧平房', '永隆汽车', 'A/B座', 'C座', '8号楼', '9号楼', '10号楼', '金渝川菜', 'G座/E座', 'roof-A', 'floor-A', 'meeting_room', '光伏集装箱', 'photovoltaic_cabinet'];
      for (let i in build_arr) {
        let now = this.g3d.dm().getDataByTag(build_arr[i]);
        if (action == 'show') {
          build_D.s({'shape3d.transparent': true, 'shape3d.opacity': 0.1});
          build_D.setStyle('wf.color', 'rgba(89, 197, 227, 0.1)');
          setVisible(now, false);
        } else {
          build_D.s({'shape3d.transparent': true, 'shape3d.opacity': 0.5});
          build_D.setStyle('wf.color', 'rgba(89, 197, 227, 1)');
          setVisible(now, true);
        }
      }
      if (action == 'show') {
        setVisible(line_west, true);
        setVisible(line_east, true);
        setVisible(elevator_west, true);
        setVisible(elevator_east, true);
        setVisible(elevator_west_info, true);
        setVisible(elevator_east_info, true);
        setVisible(elevator_west_info2, true);
        setVisible(elevator_east_info2, true);
      } else {
        elevator_west_info.s('3d.visible', false);
        elevator_east_info.s('3d.visible', false);
        elevator_west_info2.s('3d.visible', false);
        elevator_east_info2.s('3d.visible', false);
        setVisible(line_west, false);
        setVisible(line_east, false);
        setVisible(elevator_west, false);
        setVisible(elevator_east, false);
      }
    },
    showEnvPanels(action) {
      let arr = ["env-info1", "env-info2", "env-info3", "env-info4"];
      for (let i in arr) {
        let now_panel = this.g3d.dm().getDataByTag(arr[i]);
        if (action == 'show') {
          now_panel.s('3d.visible', true);
        } else {
          now_panel.s('3d.visible', false);
        }
      }

    },
    handleData(tag_name, data) {
      for (let key in tag_name._childMap) {
        if (tag_name._childMap[key]._tag) {
          let child = tag_name._childMap[key];
          let tag = child._tag;
          for (let i in data) {
            if (tag && tag === i) {
              child.a('ht.value', data[i]);
            }
          }
        }
      }
    },
    //获取接口数据
    getChart() {
      let _this = this;
      this.$get('generalsituation/index', []).then((response) => {
        _this.elec_data = response.elecChart.value;
        _this.water_data = response.waterChart.value;
        _this.air_data = response.gasChart.value;

        const chart = _this.dm.getDataByTag('chart');
        chart.a('elec_data', _this.elec_data);
        chart.a('water_data', _this.water_data);
        chart.a('air_data', _this.air_data);

        let energy_consumption = response.energyConsumption;

        let pieArr = [],
            waterObj = {},
            gasObj = {},
            elecObj = {};
        waterObj.value = energy_consumption.yearWaterPower;
        waterObj.name = '水';
        elecObj.value = energy_consumption.yearElecPower;
        elecObj.name = '电';
        gasObj.value = energy_consumption.yearGasPower;
        gasObj.name = '气';
        pieArr.push(waterObj, gasObj, elecObj)

        const pie = _this.dm.getDataByTag('pie');
        pie.a('pieData', pieArr);

        // 园区运转情况
        let operation_data = response.operation;
        let operation = _this.dm.getDataByTag("parkRun");
        _this.handleData(operation, operation_data);

        // 园区概况
        let overview_data = response.overview;
        let overview = _this.dm.getDataByTag("parkGeneral");
        _this.handleData(overview, overview_data);

        // 智能设备运转情况
        let equipment_data = response.equipment;
        let equipment = _this.dm.getDataByTag("AIEquitment");
        equipment_data.onlinePercentage = (equipment_data.onlinePercentage * 100);
        _this.handleData(equipment, equipment_data);

        // 光伏总发电量
        var totalpower = _this.dm.getDataByTag('totalPhotovoltaic');
        totalpower.a('ht.value', response.totalPhotovoltaic);

        //总装机容量
        var capacity = _this.dm.getDataByTag('totalElecTransformer');
        capacity.a('ht.value', response.installation.totalElecTransformer);
        //配电室数量
        var elecroom = _this.dm.getDataByTag('countElecTransformer');
        elecroom.a('ht.value', response.installation.countElecTransformer);

        //安全运行时间
        var run_day = _this.dm.getDataByTag('run_day');
        run_day.a('ht.value', Math.round(response.project.projectSafeRunDay));
        //总能耗
        var energy_sum = _this.dm.getDataByTag('energy_sum');
        energy_sum.a('ht.value', response.project.totalPower);
      });
      this.$get('energyconsumptionanalysis/energyanalysis', [1, 2, 0, 'day', getNowFormatDate()]).then((response) => {
        this.currentDataValueArr = response.tableContent.data
      })
    }
  }
}

</script>
<style scoped lang="scss">
@media screen and (min-width: 3800px) {
  .topLogo {
    z-index: 999;
    position: fixed;
    height: 28px;
    top: 5px;
    left: 95px;
  }
}

@media screen and (max-width: 3800px) {
  .topLogo {
    z-index: 999;
    position: fixed;
    height: 42px;
    top: 5px;
    left: 95px;
  }
}

#htWrap {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #000;

  .el-icon-arrow-right {
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    position: absolute;
    right: 20px;
    top: 13px;
    z-index: 9999999;
    cursor: pointer;
  }

  .camera-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;

    .video-details-warp {
      position: absolute;
      top: 200px;
      left: 400px;
      padding: 20px;
      z-index: 85000;
      background: #12162b;

      #myPlayer {
        width: 600px;
        height: 450px;
        z-index: 85000;
      }

      span {
        color: #8a8080;
        position: absolute;
        top: 3px;
        left: 617px;
        z-index: 850000;
        cursor: pointer;
      }
    }
  }

  .move-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #00112d;
    cursor: pointer;
    border: none;
    outline: none;
    z-index: 9999;
    width: 25px;
  }

  .logo {
    height: 47px;
    width: 150px;
  }
}
</style>
